<template>
  <div class="addOrEditKeyWorkType-container">
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      width="600px"
      style="margin-top:12vh;"
      class="option-dialog"
      :close-on-click-modal="false"
    >
      <div slot="title">{{ type == 2 ? "编辑词组" : "新增词组" }}</div>
      <el-form
        :model="formData"
        ref="SensitiveWordForm"
        label-width="110px"
        class="addKeyWork-form"
        center
      >
        <el-form-item label="词组名称" prop="wordTypeName">
          <el-input
            clearable
            size="medium"
            v-model="formData.wordTypeName"
            autocomplete="off"
            maxlength="20"
            minlength="2"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="涉及范围" prop="userId" class="el-tags-wrap">
          <el-tag
            style="margin-right:4px"
            v-for="item in userMembenNames"
            :key="item.id"
            closable
            type="small"
            @close="delSelectedHandle(item)"
          >
            {{ item.name }}
          </el-tag>
          <!-- <el-button v-if="types == 1" type="text" @click="clickAddMember()" class="tags-btn">{{userMenberList.length!=0?'修改':'添加'}}</el-button> -->
          <el-checkbox :value="checked">外部联系人(客户)</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel" style="margin-right:20px"
          >取消</el-button
        >
        <el-button type="primary" size="small" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
    <StaffTree
      title="添加成员"
      :dialogVisibleTree="dialogVisibleTree"
      :currentSelectMember="userMenberList"
      @closeTree="closeTree"
      @clickSubmitTree="clickSubmitTree"
    ></StaffTree>
  </div>
</template>

<script>
import {
  addFirstType,
  editFirstType,
  editWordType,
  addConsultStore,
  updateRuleApi,
} from "@/api/keyWords/index.js";
import { getOrganization } from "@/api/staffTree/staffTree.js";
import StaffTree from "@/components/staffTree/staffTree.vue";
export default {
  name: "optionSensitiveWordTypeDialog",
  props: {
    /** 弹窗词组名称 */
    typeTitle: {
      type: String,
      default: "",
    },
    /** 敏感词类型 1敏感词库   2 非敏感词库 */
    types: {
      type: Number,
      default: 1,
    },
    ids: {
      type: String,
      default: "",
    },
    /** 编辑类型 */
    editType: {
      type: Number,
      default: 1,
    },

    /** 关键词列表 */
    list: {
      type: Array,
      default: [],
    },

    /** 当前已有的词组数据 */
    setTree: {
      type: Array,
      default: [],
    },
  },
  components: {
    // AddMemberView,
    StaffTree,
  },
  data() {
    return {
      /** 弹窗的表单数据 */
      formData: {
        wordTypeName: "",
        userId: [],
      },
      /** 控制弹窗显示隐藏 */
      dialogVisible: false,
      /** 新增的请求参数 */
      addParams: {
        wordTypeName: "", // 词组名字
        userId: [], // 涉及范围内员工Id
      },
      /** 编辑的请求参数 */
      editPatams: {
        typeId: "",
        wordTypeName: "",
        userId: [],
      },
      userMembenNames: [],
      /** 当前选中的成员（成员数返回的数据） */
      userMenberList: [],
      title: "选择员工",
      /**  控制成员数是否可见 */
      dialogVisibleTree: false,
      /** 1 新增 2 编辑 */
      type: 1,
      /** 存储员工的数据 */
      allStaff: [],
      /** 控制外部联系人是否勾选 */
      checked: true,
      typeStatus: this.types,
      classId: this.ids,
      /** 编辑前的数据，用于编辑时候校验是否是 */
      editBeforeData: {
        wordTypeName: "",
      },
    };
  },

  methods: {
    /** 弹窗打开初始化，供父组件使用 */
    init(data) {
      if (data && data != null) {
        /** 编辑 */
        this.type = 2;
        // this.editBeforeData = JSON.parse(JSON.stringify(data))
        for (let key in data) {
          key in this.editBeforeData
            ? (this.editBeforeData[key] = data[key])
            : "";
        }
        this.formData = JSON.parse(JSON.stringify(data));
        console.log("formData++++", this.formData);
        let userIds = JSON.parse(JSON.stringify(this.formData.userId));
        console.log("allStaff", this.allStaff);
        this.userMenberList = this.allStaff.filter((v) => {
          return userIds.includes(v.userId) == true;
        });
        /** 获取显示的人员数据 */
        this.getUsersData(this.userMenberList);
      } else {
        /** 新增 */
        this.type = 1;
        /** 重置数据 */
        this.resetData();
      }
      this.dialogVisible = true;
    },

    /** 点击确定按钮触发 */
    handleSubmit() {
      console.log("setTree111++++++", this.setTree);

      /** 编辑时候，如果当前编辑词组和修改后的词组相当视为没有修改，
       * 不需要调用接口直接关闭弹窗即可
       */
      if (
        this.type === 2 &&
        this.editBeforeData.wordTypeName == this.formData.wordTypeName
      )
        return (this.dialogVisible = false);
      /** 新增的时候直接校验&编辑的时候只有输入的值不是当前值才做校验 */
      if (
        this.type === 1 ||
        (this.type === 2 &&
          this.editBeforeData.wordTypeName != this.formData.wordTypeName)
      ) {
        /** 校验添加或者修改有无重复的词组 */
        let hasKeyWordType = [];
        /** 获取父组件传过来的值 */
        if (this.setTree && this.setTree.length) {
          hasKeyWordType = this.setTree[0].children;
        }
        if (hasKeyWordType.length) {
          /** 循环判断是否存在与填写词组相同的词组 */
          let isRepeat = hasKeyWordType.some((item) => {
            return item.wordTypeName == this.formData.wordTypeName;
          });

          /** 有则进行拦截 */
          if (isRepeat) {
            this.$message.closeAll();
            return this.$message.warning("当前词组已存在，请勿重复添加");
          }
        }
      }

      if (this.type == 1) {
        // 新增词组确定事件
        this.addSensitiveWordType(this.formData);
      } else {
        // 编辑词组确定事件
        this.$confirm("您确定修改该词组？提交后将无法撤回", {
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          iconClass: "el-icon-warning",
          customClass: "delete-messege",
          center: true,
        })
          .then((res) => {
            /** 编辑词组 */
            this.updateKeyWordType(this.formData);
          })
          .catch((action) => {
            // this.$message("取消编辑");
          });
      }
    },

    /** 新建词组 */
    addSensitiveWordType(params) {
      console.log(this.$props.ids);
      console.log(params);
      let that = this;
      if (this.$props.typeTitle == "关键词库") {
        params = { ...params, classId: this.$props.ids };
        addConsultStore(
          {
            wordName: this.formData.wordTypeName,
          },
          localStorage.getItem("Authorization")
        )
          .then((res) => {
            if (res.error.code == 200) {
              that.$message.success("添加成功！");
              that.resetData();
              this.dialogVisible = false;
              this.$emit("createSuccess", "createkeyWordGroupSuccess");
            }
            // else {
            //   that.$message.error(res.error.message);
            // }
          })
          .catch((err) => {
            that.$message.error("添加失败，请重试！");
            console.log(err, "errr");
          });
      } else {
        params = { ...params, classId: this.$props.ids };
        addFirstType(params, localStorage.getItem("Authorization"))
          .then((res) => {
            if (res && res.error && res.error.code == 200) {
              that.$message.success("操作成功！");
              that.resetData();
              this.dialogVisible = false;
              this.$emit("createSuccess", "成功");
            } else {
              that.$message.error(res.error.message);
            }
          })
          .catch((err) => {
            that.$message.error("添加失败，请重试！");
            console.log(err, "errr");
          });
      }
    },

    /**  编辑词组 */
    updateKeyWordType(params) {
      console.log("params+++", params);
      let requestParams = {
        name: this.formData.wordTypeName,
        ruleId: params.ruleId || params.classId,
          /** 注意！因编辑分类和删除关键词的是同一个接口， 此字段用于后端区分删除关键词和编辑分类，编辑分类传false */
        delFlag:false,
        // wordName: this.list.length
        //   ? this.list.map((item) => item.wordName)
        //   : null,
      };
      updateRuleApi(requestParams, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res && res.error && res.error.code === 200) {
            this.$message.success(res.error.message);
            this.dialogVisible = false;
            /** 编辑成功后需要拿到新的名称去请求列表接口，没办法接口就是要这样 */
            this.$emit("createSuccess", params.wordTypeName);
          }
        })
        .catch(() => {
          this.$message.error("系统繁忙，稍后再试");
        });
    },

    /** 删除的关键词数据 */
    delSelectedHandle(data) {
      //过滤原始数据
      this.userMenberList = this.userMenberList.filter((v) => {
        return v.departmentId != data.id && v.userId != data.id;
      });
      //过滤名称数据
      this.userMembenNames = this.userMembenNames.filter((v) => {
        return v.id != data.id;
      });
      this.formData.userId = this.formData.userId.filter((v) => {
        return v != data.id;
      });
    },

    /** 点击取消触发 */
    cancel() {
      this.resetData();
      this.dialogVisible = false;
    },

    /** 重置数据 */
    resetData() {
      this.formData = {
        wordTypeName: "",
        userId: [],
      };
      this.userMenberList = [];
      this.userMembenNames = [];
    },

    /** 获取显示的人员数据 */
    getUsersData(data) {
      let memberList = JSON.parse(JSON.stringify(data));
      this.userMembenNames = [];
      memberList.map((v) => {
        this.userMembenNames.push({
          treeId: v.id, //树id
          id: v.userId ? v.userId : v.departmentId,
          name: v.userName ? v.userName : v.departmentName,
          type: v.userId ? "per" : "depart",
        });
      });
      this.userMembenNames = this.getArrSet(this.userMembenNames, "id");
    },

    /** 获取所有员工&部门数据 */
    async getDepartStaff() {
      let params = {
        mark: 2,
      };
      await getOrganization(params, localStorage.getItem("Authorization"))
        .then((res) => {
          if (res.error.code == 200) {
            this.$store.dispatch("tagsView/setTree1", res.data);
            this.allStaff = res.data.empList;
          }
        })
        .catch((err) => {});
    },

    //对象数组去重(根据userId去重)
    getArrSet(Arr, id) {
      var obj = {};
      const arrays = Arr.reduce((setArr, item) => {
        obj[item[id]] ? "" : (obj[item[id]] = true && setArr.push(item));
        return setArr;
      }, []);
      return arrays;
    },

    /** 关闭树形结构 */
    closeTree(val) {
      this.dialogVisibleTree = false;
    },

    /** 点击成员树触发 */
    clickSubmitTree(val) {
      this.userMenberList = val.currentMember;
      this.formData.userId = [];
      this.userMembenNames = JSON.parse(JSON.stringify(val.currentIdName));
      let arr = JSON.parse(JSON.stringify(val.sendArray));
      arr.forEach((item) => {
        this.formData.userId.push(item.userId);
      });
      this.dialogVisibleTree = false;
    },

    /** 点击确定触发 */
    confirm() {
      // if (this.formData.wordTypeName) {
      //   this.handleSubmit();
      //   //   if(this.typeStatus == 2 ){
      //   //     this.handleSubmit()
      //   //   }else if(this.typeStatus == 1 && this.formData.userId.length != 0){
      //   //     this.handleSubmit()
      //   //   }else {
      //   //   this.$message.warning("表单字段不能为空！")
      //   // }
      // } else {
      //   this.$message.warning("表单字段不能为空！");
      // }
      /** 企微限制不能为空且不能小于两个字  */
      if (!this.formData.wordTypeName)
        return this.$message.warning("词组名称不能为空");
      if (this.formData.wordTypeName.length < 2)
        return this.$message.warning("词组名称不能少于两个字");
      this.handleSubmit();
    },

    /** 开启选择成员弹窗 */
    clickAddMember() {
      this.dialogVisibleTree = true;
    },
  },

  /** 生命周期 */
  async created() {
    // let tree1 = this.$store.state.tagsView.tree1;
    // if (tree1 && tree1.length != 0) {
    //   this.allStaff = tree1.empList;
    // } else {
      /**  获取所有员工&部门数据  */
      await this.getDepartStaff();
    // }
  },
};
</script>

<style scoped lang="scss">
.addOrEditKeyWorkType-container {
  /deep/ .option-dialog {
    .el-dialog__body {
      padding: 30px 20px 10px 0;
      color: #606266;
      font-size: 14px;
      word-break: break-all;
      .addKeyWork-form {
        .el-input {
          width: 85%;
        }
      }
      .el-tags-wrap {
        .el-form-item__content {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          max-height: 250px;
          overflow: auto;
          min-height: 40px;
          line-height: 150%;
          .el-tag {
            margin: 4px 4px;
          }
        }
        .tags-btn {
          padding: 0;
        }
      }
    }
  }
}
</style>
